<template>
  <TContextActionMenu>
    <template #menu-button>
      <slot name="trigger" />
    </template>

    <template #default="{ close }">
      <div>
        <!-- reason for the random @dayclick handler -->
        <!-- https://github.com/nuxt/ui/issues/2208 -->
        <DatePicker
          :model-value="
            model
              ? {
                  start: model.start.toJSDate(),
                  end: model.end.toJSDate(),
                }
              : null
          "
          is-range
          :attributes="attr"
          :first-day-of-week="2"
          :locale="locale"
          @update:model-value="
            (value: DatePickerModelUpdateType) => {
              model = {
                start: DateTime.fromJSDate(value.start),
                end: DateTime.fromJSDate(value.end),
              };
              close();
            }
          "
          @dayclick="
            (_, event) => {
              event.target.blur();
            }
          "
        />
        <div class="flex w-full justify-end gap-4 p-2">
          <button
            v-if="model?.start && model?.end"
            type="button"
            class="cursor-pointer p-2"
            @click="() => deleteRangeFunction(close)"
          >
            <span class="text-primary-500 text-xs underline">
              {{ $t('generic_clear_date') }}</span
            >
          </button>
          <button
            v-if="model?.start && model?.end"
            type="button"
            class="bg-primary-500 hover:bg-primary-600 cursor-pointer rounded-md p-2"
            @click="close()"
          >
            <span class="text-white-500 text-xs">
              {{ $t('generic_close') }}</span
            >
          </button>
        </div>
      </div>
    </template>
  </TContextActionMenu>
</template>

<script lang="ts" setup>
import { $t, getUserLanguage } from '@teachino/shared-i18n';
import { DateTime } from 'luxon';
import { DatePicker } from 'v-calendar';
import TContextActionMenu from '../ContextMenu/TContextActionMenu.vue';
import type { DateRange } from './date-range';

const locale = getUserLanguage();

type DatePickerModelUpdateType = { start: Date; end: Date };

const model = defineModel<DateRange | null>({
  default: null,
});

const attr = {
  highlight: {
    class: 'bg-primary-500',
    contentClass: 'text-white-500',
  },
};

const deleteRangeFunction = (close: () => void) => {
  model.value = null;
  close();
};
</script>
